<template>

  <div class="flex flex-col h-full px-3">
    <div class="mdn-CardInstitutional mdn-CardInstitutional--default p-0 w-75">
      <div class="mdn-CardInstitutional-content">
        <div :class="['flex flex-col bg-red-dark-claro rounded-t-lg gap-2', offer?.descontoExclusivo?.esconderFlag === false ? 'pl-5 pr-5 pt-0 pb-1' : 'p-5']">
          <div v-if="offer?.descontoExclusivo?.esconderFlag === false" class="top-0 left-1/2 -translate-x-1/2 bg-white rounded-b-lg shadow-md px-2 py-1 w-38 mx-auto flex flex-row items-center">
            <BrandIconMdn
              class="w-8 pr-1"
              :brandName="offer?.descontoExclusivo?.iconeFlag"
            />
            <mdn-text class="text-black-300 font-bold text-center w-full text-sm">{{offer?.descontoExclusivo?.descricaoFlag}}</mdn-text>
          </div>
          <mdn-text class="text-yellow-300 font-bold">CONTROLE SEM FIDELIDADE</mdn-text>
          <mdn-text class="text-white font-semibold">{{offer.shortDescription}}</mdn-text>
          <mdn-text class="text-white min-h-2 text-sm">{{offer.subDescription}}</mdn-text>
          <mdn-text id="cardDataFull" class="text-white text-7xl font-bold text-center">{{offer.data.full}}GB</mdn-text>
          <div class="h-1" >
            <mdn-text v-if="offer?.data.bonus" id="cardDataSplit" class="text-white text-center text-xs">{{offerDetail}}</mdn-text>
          </div>
          <div class="flex items-center">
            <hr class="border-t border-white flex-grow mx-2">
            <span class="text-white text-2xl font-bold">+</span>
            <hr class="border-t border-white flex-grow mx-2">
          </div>
          <div class="h-36 flex items-center justify-between" style="margin-top: -10px;">
            <div class="flex flex-col items-center mr-5 ml-3 flex-grow">
              <BrandIconMdn
                  v-for="(app, index) in offer.apps.unlimited"
                  :brandName="app.icon"
                  :key="'app-icon-' + index"
                  class="w-8 mr-1 mt-1"
                />
              <mdn-text class="text-white text-sm mt-2 font-semibold">ILIMITADO</mdn-text>
            </div>
            <span class="text-yellow-400 text-4xl font-bold">+</span>
            <div class="flex flex-col items-center ml-5 flex-grow" style="width: 83px;">
              <mdn-text class="text-center text-white font-semibold mb-1">{{offer.data.apps}}GB</mdn-text>
              <div class="flex flex-wrap">
                <BrandIconMdn
                  v-for="(app, index) in offer.apps.limited"
                  :brandName="app.icon"
                  :key="'app-icon-' + index"
                  class="w-8 mr-1 mt-1"
                />
              </div>
              <mdn-text class="text-center text-white mt-2 text-sm" v-if="offer.apps.limited.length === 1">{{offer.apps.limited[0].name}}</mdn-text>
            </div>
          </div>
          <div class="flex items-center">
            <hr class="border-t border-white flex-grow mx-2">
            <mdn-text isInverse class="text-2xl font-bold text-white">+</mdn-text>
            <hr class="border-t border-white flex-grow mx-2">
          </div>
          <div class="flex flex-row gap-2 flex-wrap mb-2 items-start mx-auto">
            <BrandIconMdn
              v-for="(app, index) in offer.benefit.includedApps"
              :brandName="app.icon"
              :key="'app-icon-' + index"
              class="w-8"
            />
          </div>
          <hr class="border-t border-white mx-2" style="margin-bottom: -20px;">
          <div class="flex flex-col px-5 py-7 gap-3">
            <mdn-text id="cardPriceRecorrenciaFull" class="text-3xl font-bold text-white mx-auto">R$ {{offer.price.adesao.full}} <span class="text-lg">/mês</span></mdn-text>
            <mdn-text class="text-white mx-auto text-sm" style="margin-top: -10px;">CARTÃO DE CRÉDITO</mdn-text>

            <Button global
              :id="`offerButton-${offer.id}`"
              type="button"
              @click="selectOffer"
              class="w-min mx-auto">
              Contratar
            </Button>
          </div>
        </div>
      </div>

      <div class="flex flex-col mdn-CardInstitutional mdn-CardInstitutional--default p-0 rounded-b-none">
        <Accordion title="Apps para navegar ilimitado">
          <div class="flex flex-col gap-2">
            <div class="flex flex-row gap-2 flex-wrap items-start">
              <BrandIconMdn
                v-for="(app, index) in offer.apps.unlimited"
                :brandName="app.icon"
                :key="'app-icon-' + index"
                class="w-8"
              />
            </div>

            <AppDescription
              v-for="(app, index) in offer.apps.unlimited"
              :key="'app-icon-' + index"
              :name="app.name"
              :description="app.description"
            />

          </div>
        </Accordion>
      </div>

      <div class="flex mdn-CardInstitutional mdn-CardInstitutional--default p-0 rounded-b-none">
        <div class="flex flex-col gap-2 p-4">

          <div @click="showDetail" class="flex flex-row w-full justify-between">
            <div class="flex flex-row gap-2 items-center">
              <span class="mdn-Icon-circulo-i mdn-Icon--md"></span>
              <mdn-text>Detalhe</mdn-text>
            </div>
            <span class="mdn-Icon-direita mdn-Icon--md"></span>

          </div>

          <div class="border-t-2"></div>

          <div @click="showBenefit" class="flex flex-row w-full justify-between">
            <div class="flex flex-row gap-2 items-center">
              <span class="mdn-Icon-presente mdn-Icon--md"></span>
              <mdn-text>Benefício</mdn-text>
            </div>
            <span class="mdn-Icon-direita mdn-Icon--md"></span>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import OfferCommon from './OfferCommon'
import AppDescription from './AppDescription.vue'
import { MdnText, Button } from 'mondrian-vue'
import Accordion from '../../../components/Accordion.vue'
import BrandIconMdn from '../../../components/BrandIconMdn.vue'

export default {
  name: 'PlanOffer',
  components: { MdnText, Button, Accordion, AppDescription, BrandIconMdn },
  extends: OfferCommon,
  data: () => ({
    showInfo: false
  }),
  methods: {
    showOrHideInfo () {
      this.showInfo = !this.showInfo
    },
    showDetail () {
      this.$emit('showDetails', { ...this.offer })
    },
    showBenefit () {
      this.$emit('showBenefits', { ...this.offer })
    }
  },
  computed: {
    offerDetail () {
      const main = `${this.offer.data?.main}GB`
      const bonus = this.offer.data?.bonus ? `+ ${this.offer.data?.bonus}GB de bônus por 12 meses` : ''
      return [main, bonus].join(' ')
    }
  }
}
</script>
